





























































































































































import { computed, defineComponent, onMounted, ref, watch } from '@nuxtjs/composition-api';
import { SfButton, SfIcon } from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';
import { useValidator } from '~/composables';
import JetInput from '../../atoms/Input/JetInput.vue';
import JetUiButton from '../../atoms/JetUiButton/JetUiButton.vue';
import Warning from '../../atoms/Warning/Warning.vue';

export default defineComponent({
    name: 'InsertNewCard',
    components: {
        JetInput,
        JetUiButton,
        SfButton,
        SfIcon,
        Warning,
        SvgImage
    },
    setup(_, { emit }) {
        const { validateCPF } = useValidator();
        const form = ref({
            number: '',
            name: '',
            month: '',
            year: '',
            cvv: '',
            cpf: '',
            cardBrand: ''
        });
        const allowedcardBrands = ['hipercard', 'elo', 'mastercard', 'visa'];
        const minYear = ref(new Date().getFullYear());
        const amexCardMask = ref('**** ****** *****');
        const otherCardMask = ref('**** **** **** ****');
        const numberTemp = ref('');
        const isCardFlipped = ref(false);
        const focusElementStyle = ref<any>(null);
        const isInputFocused = ref(false);
        const cardBrandWarning = ref(false);

        onMounted(() => {
            numberTemp.value = otherCardMask.value;
            document.getElementById('number')?.focus();
        });

        const getcardBrand = computed(() => {
            const number = form.value.number.split(' ').join('');
            const patterns = {
                elo: /^4011|^4312|^4389|^4514|^4576|^5041|^5066|^509[0-9]|^6277|^6362|^6363|^650[4-9]|^6516|^6550/,
                visa: /^4/,
                mastercard: /^5[1-5]|^222[1-9]|^22[3-9]|^2[3-6]|^27[01]|^2720/,
                hipercard: /^606282|^3841|^637095|^637612|^637599|^637609|^637568/,
                amex: /^34|^37/
            };

            for (const [type, pattern] of Object.entries(patterns)) {
                if (pattern.test(number)) return type;
            }
            return '';
        });


        watch(() => form.value.number, (newNumber) => {
            form.value.cardBrand = getcardBrand.value;
            form.value.cardBrand === '' ? cardBrandWarning.value = true : cardBrandWarning.value = false;
        });


        const disabled = computed(() => {

            if (form.value.cvv.length < 3) return true;

            const isCardAllowed = allowedcardBrands.includes(form.value.cardBrand);
            return (
                !isCardAllowed ||
                Object.values(form.value).some(value => value === '' || value === null || value === undefined)
            );
        });


        const minMonth = computed(() => {
            return parseFloat(form.value.year) === minYear.value ? new Date().getMonth() + 1 : 1;
        });

        const flipCard = (status: boolean) => {
            isCardFlipped.value = status;
        };

        const focusInput = (e: Event) => {
            isInputFocused.value = true;
            const target = e.target as HTMLInputElement;
            const targetRef = target.dataset.ref;
            const element = document.querySelector(`[data-ref="${targetRef}"]`) as HTMLElement;

            if (element) {
                focusElementStyle.value = {
                    width: `${element.offsetWidth}px`,
                    height: `${element.offsetHeight}px`,
                    transform: `translateX(${element.offsetLeft}px) translateY(${element.offsetTop}px)`,
                };
            }
        };

        const blurInput = () => {
            setTimeout(() => {
                if (!isInputFocused.value) {
                    focusElementStyle.value = null;
                }
            }, 300);
            isInputFocused.value = false;
        };

        const maxLength = computed(() => numberTemp.value.length);

        const handleSubmit = () => {
            if (allowedcardBrands.includes(form.value.cardBrand)) {
                emit('submit', form.value);
            } else {
                alert('A bandeira do cartão não é aceita.');
            }
        };

        return {
            form,
            minYear,
            amexCardMask,
            otherCardMask,
            numberTemp,
            isCardFlipped,
            focusElementStyle,
            isInputFocused,
            getcardBrand,
            minMonth,
            flipCard,
            focusInput,
            blurInput,
            maxLength,
            handleSubmit,
            validateCPF,
            disabled,
            cardBrandWarning
        };
    },
});
